import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

document.querySelectorAll('.element-feature-boxes').forEach((element) => {
    new Swiper(element.querySelector('.swiper'), {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 500,
        navigation: {
            prevEl: element.querySelector('.element-feature-boxes__navigation-button--prev'),
            nextEl: element.querySelector('.element-feature-boxes__navigation-button--next'),
        },
        breakpoints: {
            1280: {
                enabled: false,
            },
        }
    })
});
